import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {SearchKey} from '../models/search-key';

@Injectable({
    providedIn: 'root'
})
export class SearchService {

    constructor(private http: HttpClient) {
    }

    getSearchKey(): Observable<SearchKey> {
        return this.http.get<SearchKey>(`${environment.apiBaseUrl}search-key`);
    }
}
